"use client";

import Link from "next/link";

import { PrimCallout } from "@/shared-web.ui/prim.callout";
import { semanticColor } from "@/shared-web.ui/styles";
import { Button } from "@/shared-web.ui/ui.button";
import { Flex } from "@/shared-web.ui/ui.flex";
import { Text } from "@/shared-web.ui/ui.text";
import { getCurrentUrl, getLoginUrl } from "@/shared-web.ui/util.login";

const GuestLoginCallout = () => {
  const handleLoginClick = (type: "login" | "signup"): string => {
    const redirectToUrl = getCurrentUrl();
    const loginHref = getLoginUrl(redirectToUrl, {
      forAccountMerge: true,
      getSignupUrl: type === "signup",
    });

    return loginHref;
  };

  return (
    <PrimCallout.Root color={semanticColor.info}>
      <Flex direction="column" gap="3">
        <Text
          weight="bold"
          className="leading-2"
        >
          Create an account to track your orders
        </Text>
        <Text size="2">
          Sign up now to manage your orders,
          track deliveries, and get personalized
          recommendations.
        </Text>
        <Flex justify="between" gap="2">
          <Link
            href={handleLoginClick("login")}
            prefetch
            scroll={false}
            className="flex-1"
          >
            <Button variant="outline" className="w-full">
              Log in
            </Button>
          </Link>
          <Link
            href={handleLoginClick("signup")}
            prefetch
            scroll={false}
            className="flex-1"
          >
            <Button className="w-full">
              Sign up
            </Button>
          </Link>
        </Flex>
      </Flex>
    </PrimCallout.Root>
  );
};

export { GuestLoginCallout };
